/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/form/field/select/select_styles';



/* ========== ~~~~~~~~~~ FORM : FIELD  : SELECT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const SelectField = (props) => {
	return (
		<select
			className={`select ${props.classes.select}`}
			type={`text`}
			name={props.name}
			value={props.value}
			readOnly={props.readOnly ? props.readOnly : false}
			onFocus={props.handleFocus}
			onBlur={props.handleBlur}
			onChange={props.handleChange}
			disabled={props.disabled}
		>
            <option  name={''} value={''} disabled>{!!props.dummyOptionText ? props.dummyOptionText : 'Select your option'}</option>
			{props.options.map((option, index) => <option key={index} name={option.name} value={option.value}>{option.text}</option> )}
		</select>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SelectField);